import { PlacardsAndMarkings } from '../maps/types/scalars';


export type HacpackQuery = {
    __typeName: 'HacpackQuery',
    currentUser?: User | null,
    registrationToken?: RegistrationTokenSummary | null,
    passwordResetToken?: boolean | null,
    users?: Array<User> | null,
    groups?: Array<Group> | null,
    terminal?: Terminal | null,
    handling?: Handling | null,
    unNumbers?: Array<Adr>,
    emergencyCards?: Array<EmergencyCard>,
    emergencyCardAssetsBaseUrl?: string | null,
    packagings?: Array<Packaging>,
    extraPmisPackagings?: Array<ExtraPmisPackaging>
};

export type HacpackQueryRegistrationTokenArguments = {
    token: string
};

export type HacpackQueryPasswordResetTokenArguments = {
    token: string
};

export type HacpackQueryTerminalArguments = {
    id: number
};

export type HacpackQueryHandlingArguments = {
    id: number
};

export type HacpackQueryUnNumbersArguments = {
    unNumbers?: Array<string> | null,
    unPgCls?: Array<UnPgClInput> | null
};

export type User = {
    __typeName: 'User',
    id?: number,
    login?: string,
    displayName?: string | null,
    email?: string,
    managerId?: number | null,
    memberships?: Array<Membership>,
    roles?: Array<Role> | null,
    terminals?: Array<Terminal> | null
};

export type Membership = {
    __typeName: 'Membership',
    user?: User | null,
    group?: Group | null,
    roles?: Array<Role> | null
};

export type Group = {
    __typeName: 'Group',
    id?: number,
    name?: string,
    terminalNames?: Array<string> | null,
    portCodes?: Array<string> | null,
    roles?: Array<Role>
};

export type Role = {
    __typeName: 'Role',
    id?: number,
    name?: string,
    group?: Group,
    users?: Array<User>
};

export type Terminal = {
    __typeName: 'Terminal',
    id?: number,
    name?: string,
    slug?: string,
    port?: string,
    portCode?: string,
    active?: boolean,
    ceiLimit?: number | null,
    feiLimit?: number | null,
    radiusLimit?: number | null,
    teusLimit?: number | null,
    centerLatitude?: number | null,
    centerLongitude?: number | null,
    authorityType?: string | null,
    mapZoom?: number | null,
    northLatitude?: number | null,
    southLatitude?: number | null,
    westLongitude?: number | null,
    eastLongitude?: number | null,
    maxStorageDays?: number | null,
    storageWarningDays?: number | null,
    handlings?: Array<Handling>,
    dataUpdate?: DataUpdate | null,
    riskAssessments?: Array<RiskAssessment>,
    segregations?: Array<Segregation>,
    areas?: Array<TerminalArea>,
    mailingListsForTerminalsDataSend?: Array<MailingListsForTerminalsDataSend>
};

export type MailingListsForTerminalsDataSend = {
    __typeName: 'MailingListsForTerminalsDataSend',
    id?: number,
    terminalName?: string,
    description?: string,
    distributionList?: string,
    emails?: string[]
};

export type TerminalHandlingsArguments = {
    checkedIn?: boolean | null,
    checkedOut?: boolean | null,
    types?: Array<HandlingType | null> | null,
    loadingUnitIdentifiers?: Array<string | null> | null
};

export type Handling = {
    __typeName: 'Handling',
    id?: number,
    terminalName?: string,
    creationDate?: string,
    loadingUnitIdentifier?: string,
    checkedIn?: boolean,
    checkedOut?: boolean,
    checkInDate?: string | null,
    checkOutDate?: string | null,
    area?: string | null,
    bay?: string | null,
    row?: string | null,
    tier?: string | null,
    approval?: string | null,
    loadingUnitSize?: string | null,
    loadingUnitType?: string | null,
    loadingUnitSizeFromGate?: string | null,
    shippingAgencyOrCarrier?: string | null,
    shippingCompany?: string | null,
    ship?: string | null,
    unboardingShip?: string | null,
    boardingShip?: string | null,
    voyage?: string | null,
    originVoyage?: string | null,
    destinationVoyage?: string | null,
    originLocode?: string | null,
    destinationLocode?: string | null,
    type?: HandlingType | null,
    equipmentType?: string | null,
    direct?: boolean,
    approvedByTerminal?: boolean,
    checkedByTerminal?: boolean,
    prescriptions?: string | null,
    boardingPrescriptions?: string | null,
    unboardingPrescriptions?: string | null,
    booking?: string | null,
    bookingFromTerminal?: string | null,
    boardingShipFromTerminal?: string | null,
    unboardingShipFromTerminal?: string | null,
    qsaNotes?: string | null,
    deleted?: boolean,
    deletedAt?: string | null,
    deletedBy?: string,
    acceptedForStorageOverTimeLimit?: boolean | null,
    authorityId?: string | null,
    terminalOpinionDate?: string | null,
    bookingCheckResult?: boolean | null,
    storageDays?: number | null,
    cei?: number | null,
    fei?: number | null,
    standardDistance?: number | null,
    terminal?: Terminal,
    dangerousGoods?: Array<DangerousGoods> | null,
    dangerousGoodsCount?: number | null,
    totalWeight?: number | null,
    portAuthorityAuthorization?: PortAuthorityAuthorization | null,
    harbourOfficeAuthorization?: HarbourOfficeAuthorization | null,
    chemistDocuments?: Array<HandlingAttachment> | null,
    placardsAndMarkings?: PlacardsAndMarkings | null,
    imdgGateAttachments?: Array<ImdgGateAttachment> | null,
    shipArrival?: ShipArrival | null,

    idSerchim?: number | null,
    goodsDataModified?: boolean | null,
    goodsDataModifiedAt?: string | null,
    prescriptionsModified?: boolean | null,
    prescriptionsModifiedAt?: string | null,

    serchimNotes?: string | null,
    approvedBySerchim?: boolean | null,
    assignedDate?: string | null,
    serchimShippingCompany?: string | null,
    chemistPrescriptionsUrl?: string | null,
    safetyDataSheetUrls?: Array<string> | null,
    requestedDate?: string | null
};

export type ShipArrival = {
    uid?: string,
    id?: number,
    name?: string,
    shippingAgency?: string,
    ship?: string,
    eta?: string,
    etd?: string | null
}

/*
            Field<NonNullGraphType<LongGraphType>, long>()
                .Name("id")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.Chiave);

            Field<NonNullGraphType<StringGraphType>, string>()
                .Name("name")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.IdViaggio);

            Field<StringGraphType, string>()
                .Name("agency")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.Agenzia);

            Field<StringGraphType, string>()
                .Name("ship")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.NomeNave);

            Field<NonNullGraphType<DateTimeGraphType>, DateTime>()
                .Name("eta")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.Eta);

            Field<DateTimeGraphType, DateTime?>()
                .Name("etd")
                .Resolve((IResolveFieldContext<IArrivoNave> context) => context.Source.Arrivata ? context.Source.Etd : null);
 
  */

export enum HandlingType {
    None = "NONE",
    Transit = "TRANSIT",
    Boarding = "BOARDING",
    Unboarding = "UNBOARDING",
    TranshipmentUnboarding = "TRANSHIPMENT_UNBOARDING",
    TranshipmentBoarding = "TRANSHIPMENT_BOARDING"
};

export type DangerousGoods = {
    __typeName: 'DangerousGoods',
    id?: number,
    unNumber?: string,
    packingGroup?: string,
    packaging?: string | null,
    type?: HandlingType | null,
    weight?: number | null,
    numberOfPackages?: number | null,
    provision274?: string,
    flashPoint?: string,
    adrClass?: string | null,
    adrSecondaryClasses?: Array<string | null>,
    marinePollutant?: boolean,
    limitedQuantity?: boolean,
    fumigated?: boolean,
    coolingAgents?: boolean,
    elevatedTemperature?: boolean,
    authorityId?: string | null,
    handling?: Handling | null,
    safetyDataSheet?: HandlingAttachment | null,
    properShippingName?: string | null,
    emergencyCardUrl?: string | null,
    imdgGateAttachments?: Array<ImdgGateAttachment> | null
};

export type HandlingAttachment = {
    __typeName: 'HandlingAttachment',
    id?: number,
    loadingUnit?: string,
    ship?: string,
    shippingAgencyOrCarrier?: string,
    voyage?: string,
    documentName?: string,
    documentType?: AttachmentDocumentType | null,
    dangerousGoodsKey?: number | null,
    handlingId?: number | null,
    dangerousGoodsId?: number | null,
    terminalName?: string | null,
    documentTitle?: string | null,
    downloadUrl?: string | null
};

export enum AttachmentDocumentType {
    Multimodal = "MULTIMODAL",
    SafetyDataSheet = "SAFETY_DATA_SHEET",
    ChemistDocument = "CHEMIST_DOCUMENT"
};

export type ImdgGateAttachment = {
    __typeName: 'ImdgGateAttachment',
    id?: number,
    handlingAuthorityId?: number | null,
    handlingFascicleId?: number | null,
    goodsAuthorityId?: number | null,
    description?: string,
    filename?: string,
    format?: ImdgGateAttachmentFormat | null,
    downloadUrl?: string | null
};

export enum ImdgGateAttachmentFormat {
    Jpg = "JPG",
    Png = "PNG",
    Pdf = "PDF",
    Doc = "DOC",
    Docx = "DOCX",
    Xls = "XLS",
    Xlsx = "XLSX",
    Gif = "GIF",
    Bmp = "BMP",
    P7M = "P_7_M"
};

export type PortAuthorityAuthorization = {
    __typeName: 'PortAuthorityAuthorization',
    id?: number,
    fileNumber?: number,
    shippingAgencyOrCarrier?: string,
    type?: string,
    dispatchDate?: string | null,
    authorized?: boolean,
    authorizationDate?: string | null,
    terminalName?: string,
    ship?: string,
    voyage?: string,
    handlingLoadingUnitIdentifier?: string | null,
    downloadUrl?: string | null
};

export type HarbourOfficeAuthorization = {
    __typeName: 'HarbourOfficeAuthorization',
    handlingId?: number,
    authorization?: AuthorizationType | null,
    creationDate?: string | null,
    approvalId?: string | null
};

export enum AuthorizationType {
    None = "NONE",
    Transit = "TRANSIT",
    Boarding = "BOARDING",
    Unboarding = "UNBOARDING"
};

export type DataUpdate = {
    __typeName: 'DataUpdate',
    id?: number,
    type?: string,
    name?: string,
    port?: string,
    lastUpdate?: string
};

export type RiskAssessment = {
    __typeName: 'RiskAssessment',
    id?: number,
    terminalName?: string,
    area?: string,
    fei?: number | null,
    feiBay?: string | null,
    feiRow?: string | null,
    cei?: number | null,
    ceiBay?: string | null,
    ceiRow?: string | null,
    radius?: number | null,
    maxRadius2?: number | null,
    radiusBay?: string | null,
    radiusRow?: string | null,
    radiusF2?: string | null,
    radius2F2?: string | null,
    risk?: string | null,
    risk2?: string | null,
    radiusR2?: string | null,
    radius2R2?: string | null,
    radiusF2R2?: string | null,
    radius2F2R2?: string | null,
    result?: boolean | null,
    error?: string | null,
    highRadius?: boolean
};

export type Segregation = {
    __typeName: 'Segregation',
    id?: number,
    loadingUnit1Identifier?: string,
    loadingUnit2Identifier?: string,
    class1?: string,
    class2?: string,
    row1?: string,
    row2?: string,
    bay1?: string,
    bay2?: string,
    area?: string,
    terminalName?: string,
    dateOfInput?: string
};

export type TerminalArea = {
    __typeName: 'TerminalArea',
    id?: number | null,
    terminalId?: number,
    name?: string,
    description?: string | null,
    centerLatitude?: number,
    centerLongitude?: number,
    warningThreshold?: number | null,
    alertThreshold?: number | null,
    alarmThreshold?: number | null
};

export type RegistrationTokenSummary = {
    __typeName: 'RegistrationTokenSummary',
    id?: number,
    email?: string | null,
    forceEmail?: boolean,
    membership?: Membership
};

export type Adr = {
    __typeName: 'Adr',
    id?: number,
    un?: string,
    packingGroup?: string,
    hazardCls?: string,
    properShippingName?: string,
    emergencyCardUrl?: string | null
};

export type UnPgClInput = {
    unNumber: string,
    packingGroup: string,
    hazardClass: string
};

export type EmergencyCard = {
    __typeName: 'EmergencyCard',
    hazardClass?: string,
    unNumber?: string,
    url?: string
};

export type Packaging = {
    __typeName: 'Packaging',
    id?: number,
    code?: string,
    description?: string,
    fullName?: string
};

export type ExtraPmisPackaging = {
    __typeName: 'ExtraPmisPackaging',
    id?: number,
    name?: string
};

export type HacpackMutation = {
    __typeName: 'HacpackMutation',
    signIn?: UserResult | null,
    signOut?: Result | null,
    register?: Result | null,
    redeemInvitationToken?: Result | null,
    updateTerminalMapView?: Terminal | null,
    addTerminalArea?: TerminalArea | null,
    updateTerminalArea?: TerminalArea | null,
    deleteTerminalArea?: Result | null,
    createUser?: UserResult | null,
    addOrChangeMembership?: UserResult | null,
    confirmEmail?: Result | null,
    requestPasswordReset?: Result | null,
    changePassword?: UserResult | null,
    createOrUpdateHandlings?: HandlingsResult | null,
    deleteHandlingsHarbourOfficeApprovals?: Result | null,
    approveHandlings?: Result | null,
    qsaHandlingOpinion?: Result | null,
    qsaHandlingNotes?: Result | null,
    changeHandlingPosition?: Result | null,
    deleteHandlings?: Result | null,
    assignDateToHandlings?: Result | null,
    assignDatesToHandlings?: Result | null,
    sendData?: Result | null;
    testPositions?: TestPositionsResult | null;
};

export type HacpackMutationSignInArguments = {
    credentials: SignInInput
};

export type HacpackMutationRegisterArguments = {
    email: string,
    password: string,
    token: string,
    displayName?: string | null
};

export type HacpackMutationRedeemInvitationTokenArguments = {
    token: string
};

export type HacpackMutationUpdateTerminalMapViewArguments = {
    terminalMapView: TerminalMapViewInput
};

export type HacpackMutationAddTerminalAreaArguments = {
    terminalArea: TerminalAreaInput
};

export type HacpackMutationUpdateTerminalAreaArguments = {
    terminalArea: TerminalAreaInput
};

export type HacpackMutationCreateUserArguments = {
    user: UserInput
};

export type HacpackMutationAddOrChangeMembershipArguments = {
    groupId: number,
    roleIds: Array<number | null>,
    userId?: number | null,
    email?: string | null,
    managerId?: number | null,
    message?: string | null,
    forceEmail?: boolean | null
};

export type HacpackMutationConfirmEmailArguments = {
    token: string
};

export type HacpackMutationRequestPasswordResetArguments = {
    loginOrEmail?: string | null
};

export type HacpackMutationChangePasswordArguments = {
    token?: string | null,
    oldPassword?: string | null,
    password: string
};

export type HacpackMutationCreateOrUpdateHandlingsArguments = {
    handlings: Array<HandlingInput>,
    authorize?: boolean | null
};

export type HacpackMutationAssignDateToHandlingsArguments = {
    ids: Array<number>,
    date: string
};

export type HacpackMutationAssignDatesToHandlingsArguments = {
    handlingDates: Array<HandlingDateInput>,
};

export type HacpackMutationApproveHandlingArguments = {
    id: number,
    qsaNotes: string
};

export type HacpackMutationDeleteHandlingsHarbourOfficeApprovalsArguments = {
    handlingIds: Array<number>
};

export type HacpackMutationApproveHandlingsArguments = {
    handlingIds: Array<number>
};

export type HacpackMutationQsaHandlingOpinionArguments = {
    handlingId: number,
    opinion: boolean,
    qsaNotes?: string | null
};

export type HacpackMutationQsaHandlingNotesArguments = {
    handlingId: number,
    qsaNotes?: string | null
};

export type HacpackMutationChangeHandlingPositionArguments = {
    handlingId: number,
    checkedIn?: boolean | null,
    checkedOut?: boolean | null,
    area?: string | null,
    bay?: string | null,
    row?: string | null,
    tier?: string | null
};

export type HacpackMutationDeleteHandlingsArguments = {
    handlingIds: Array<number>
};

export type HacpackMutationSendDataArguments = {
    mailingListsIds: Array<number> | null,
    handlingIds: Array<number>,
    additionalAddresses: Array<string> | null,
    message: string | null
};

//Field<TestPositionsResultGraphType, MutationResult<IEnumerable<SegregationError>>>()
//    .Name("testPositions")
//    .Argument<NonNullGraphType<StringGraphType>>("terminalName")
//    .Argument<NonNullGraphType<ListGraphType<NonNullGraphType<HandlingOverrideInputGraphType>>>>("handlingOverrides")
//    .ResolveAsync(_testPositions);

export type HacpackMutationTestPositionsArguments = {
    terminalName: string,
    handlingOverrides: Array<HandlingOverrideInput>
};


export type UserResult = {
    __typeName: 'UserResult',
    isOk?: boolean,
    data?: User | null
};

export type SignInInput = {
    loginOrEmail: string,
    password: string,
    rememberMe: boolean
};

export type Result = {
    __typeName: 'Result',
    isOk?: boolean
};

export type SignInResult = {
    __typeName: 'SignInResult',
    isOk?: boolean
};

export type TerminalMapViewInput = {
    id: number,
    centerLatitude?: number | null,
    centerLongitude?: number | null,
    mapZoom?: number | null,
    northLatitude?: number | null,
    southLatitude?: number | null,
    westLongitude?: number | null,
    eastLongitude?: number | null
};

export type TerminalAreaInput = {
    id?: number | null,
    terminalId: number,
    name: string,
    centerLatitude: number,
    centerLongitude: number
};

export type HandlingDateInput = {
    handlingId: number,
    checkInDate: string
}

export type UserInput = {
    id?: number | null,
    login: string,
    displayName?: string | null,
    email: string
};

export type HandlingsResult = {
    __typeName: 'HandlingsResult',
    isOk?: boolean,
    data?: Array<Handling> | null
};

export type HandlingInput = {
    id: number,
    terminalName: string,
    deleted?: boolean | null,
    loadingUnitIdentifier: string,
    checkedIn?: boolean | null,
    checkedOut?: boolean | null,
    checkInDate?: string | null,
    checkOutDate?: string | null,
    area?: string | null,
    bay?: string | null,
    row?: string | null,
    tier?: string | null,
    loadingUnitType?: string | null,
    loadingUnitSize?: string | null,
    loadingUnitSizeFromGate?: string | null,
    shippingAgencyOrCarrier?: string | null,
    ship?: string | null,
    unboardingShip?: string | null,
    boardingShip?: string | null,
    voyage?: string | null,
    originVoyage?: string | null,
    originLocode?: string | null,
    destinationVoyage?: string | null,
    destinationLocode?: string | null,
    type?: HandlingType | null,
    equipmentType?: string | null,
    direct?: boolean | null,
    approvedByTerminal?: boolean | null,
    checkedByTerminal?: boolean | null,
    prescriptions?: string | null,
    boardingPrescriptions?: string | null,
    unboardingPrescriptions?: string | null,
    booking?: string | null,
    bookingFromTerminal?: string | null,
    boardingShipFromTerminal?: string | null,
    unboardingShipFromTerminal?: string | null,
    qsaNotes?: string | null,
    cei?: number | null,
    fei?: number | null,
    standardDistance?: number | null,
    dangerousGoods?: Array<DangerousGoodsInput> | null
};

export type DangerousGoodsInput = {
    id: number,
    unNumber: string,
    packingGroup: string,
    packaging?: string | null,
    type: HandlingType,
    weight?: number | null,
    numberOfPackages?: number | null,
    provision274?: string | null,
    flashPoint?: string | null,
    adrClass: string,
    adrSecondaryClasses?: Array<string> | null,
    marinePollutant?: boolean | null,
    limitedQuantity?: boolean | null,
    fumigated?: boolean | null,
    coolingAgents?: boolean | null,
    elevatedTemperature?: boolean | null
};

export type HandlingOverrideInput = {
    //Field(x => x.HandlingId);
    //Field(x => x.Ignore, nullable: true);
    //Field(x => x.Area, nullable: true);
    //Field(x => x.Bay, nullable: true);
    //Field(x => x.Row, nullable: true);
    //Field(x => x.Tier, nullable: true);
    handlingId: number,
    ignore?: string | null,
    area?: string | null,
    bay?: string | null,
    row?: string | null,
    tier?: string | null,
};

export type TestPositionsResult = {
    __typeName: 'TestPositionsResult',
    isOk?: boolean,
    data?: Array<Segregation> | null
};